import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';

import Avatar from '@material-ui/core/Avatar';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';

import { withStyles } from '@material-ui/core/styles';

import avatar from '@material-ui/core/colors/amber';

import { startEditBidTask } from '../../../../store/actions/bids';
import { startEditBidEditorState } from '../../../../store/actions/bidEditor';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
  },
  avatar: {
    margin: '10px',
    color: '#fff',
    backgroundColor: avatar[500],
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginBottom: theme.spacing.unit*2,
    flexGrow: 1,
  },
  title: {
    marginRight: theme.spacing.unit*3,
  },
  estimate: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginBottom: theme.spacing.unit*2,
  },
});

const Header = (props) => {
  const {
    classes,
    type,
    preview,
    bidTask,
    showValidation,
    bidValidation,
    focusType,
    startEditBidTask,
    startEditBidEditorState,
  } = props;

  return(
    <div className={classes.root}>
      <Avatar className={classes.avatar}>{type.substring(0,1).toUpperCase()}</Avatar>
      <TextField
        error={(showValidation && !!bidValidation.validateField(`title-${bidTask.id}`))}
        helperText={(showValidation && bidValidation.validateField(`title-${bidTask.id}`))}
        disabled={preview}
        id="title"
        label="Title"
        className={classNames(classes.textField, classes.title)}
        placeholder="Enter title"
        margin="normal"
        value={bidTask.title}
        onFocus={() => startEditBidEditorState(focusType)}
        onChange={(event) => {
          const value = event.target.value;
          startEditBidTask(bidTask.id, {title: value})
        }}
      />
      {type === "simple" &&
        <TextField
          error={(showValidation && !!bidValidation.validateField(`estimate-${bidTask.id}`))}
          helperText={(showValidation && bidValidation.validateField(`estimate-${bidTask.id}`))}
          disabled={preview}
          id="estimateAmount"
          type="number"
          label="Estimate Amount"
          className={classes.estimate}
          margin="normal"
          value={bidTask.estimate}
          onFocus={() => startEditBidEditorState("jobTasksEstimateAmount")}
          onChange={(event) => {
            const value = event.target.value;
            startEditBidTask(bidTask.id, {estimate: value})
          }}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
        />
      }
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const { id: bidId, showValidation } = state.adminState.bid;
  const bidValidation = state.validation.bids.find(item => item.id === bidId);

  return ({
    bidValidation,
    showValidation,
  });
};

const mapDispatchToProps = (dispatch) => ({
  startEditBidTask: (bidTaskId, update) => dispatch(startEditBidTask(bidTaskId, update)),
  startEditBidEditorState: (key) => dispatch(startEditBidEditorState(key)),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(Header);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Detail/Header.jsx